/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";

const API_URL = process.env.REACT_APP_API_URL;

const getBankDetailsByRoutingNumber = async (routingNumber: string) => {
  try {
    const response = await axios.post(
      `${API_URL}get-bank-details`,
      { routingNumber }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bank details by routing number:", error);
    throw error;
  }
};

const listBankData = async (ChefId: any) => {
  const response = await axios.post(`${API_URL}list-bank/${ChefId}`);
  return response.data;
};

const listWalletAmount = async (ChefId: any) => {
  const response = await axios.post(`${API_URL}wallet-amount/${ChefId}`);
  return response.data;
};

const listChefWelletDetail = async (ChefId: any, data?: any) => {
  const response = await axios.post(`${API_URL}list-wallet/${ChefId}`, data);
  return response.data;
};

const listChefSettlement = async (chefId: any) => {
  const response = await axios.post(`${API_URL}list-settlement`, { chefId });
  return response.data;
};

const ChefSettlementDetail = async (settlementId: any) => {
  const response = await axios.get(`${API_URL}view-settlement/${settlementId}`);
  return response.data;
};

const listChefTransactionDetail = async (ChefId: any) => {
  const response = await axios.post(`${API_URL}list-transaction/${ChefId}`);
  return response.data;
};

// Renamed to match backend logic, still using the /add-bank endpoint
const addChefBankDetail = async (data: any) => {
  const res = await axios.post(`${API_URL}add-bank`, data);
  return res.data;
};

const updateBank = async (id: any, updatedData: any) => {
  const res = await axios.put(`${API_URL}update-bank/${id}`, updatedData);
  return res.data;
};

const deleteBank = async (id: any) => {
  const response = await axios.post(`${API_URL}delete-bank/${id}`);
  return response.data;
};

const viewBankById = async (id: any) => {
  const response = await axios.get(`${API_URL}view-bank/${id}`, getToken());
  return response.data;
};

export {
  listBankData,
  listChefWelletDetail,
  listChefSettlement,
  ChefSettlementDetail,
  addChefBankDetail,
  updateBank,
  deleteBank,
  viewBankById,
  listWalletAmount,
  getBankDetailsByRoutingNumber,
  listChefTransactionDetail,
};
